import personal from '../views/personal/index'
import giftMenber from '../views/personal/giftMenber'
import helpOpen from '../views/personal/helpOpen'
import custom from '../views/personal/custom'
import customDetails from '../views/personal/customDetails'
import balance from '../views/personal/balance'
import recharge from '../views/personal/recharge'
import balanceList from '../views/personal/balanceList'
import balanceDetail from '../views/personal/balanceDetail'
import withdrawal from '../views/personal/withdrawal'
import uploadIDCard from '../views/personal/uploadIDCard'
import balances from '../views/personal/balances'
import vipTypeInfo from '../views/vipTypeInfo'
import daijiesuan from '../views/personal/daijiesuan'
import setPassword from '../views/personal/setPassword'

const personalRouter = [
  {
    path: '/personal',
    name: '个人中心',
    meta: {
      moduleName: '个人中心'
    },
    component: personal,
  },
  {
    path: '/giftMenber',
    name: '赠送会员',
    meta: {
      moduleName: '赠送会员'
    },
    component: giftMenber,
  },
  {
    path: '/helpOpen',
    name: '帮亲友开通会员',
    meta: {
      moduleName: '帮亲友开通会员'
    },
    component: helpOpen,
  },
  {
    path: '/custom',
    name: '我的客户',
    meta: {
      moduleName: '我的客户'
    },
    component: custom
  },
  {
    path: '/customDetails',
    name: '我的客户',
    meta: {
      moduleName: '我的客户'
    },
    component: customDetails
  },
  {
    path: '/balance',
    name: '账户余额',
    meta: {
      moduleName: '账户余额'
    },
    component: balance,
  },
  {
    path: '/recharge',
    name: '充值',
    meta: {
      moduleName: '充值'
    },
    component: recharge,
  },
  {
    path: '/balanceList',
    name: '余额明细',
    meta: {
      moduleName: '余额明细'
    },
    component: balanceList,
  },
  {
    path: '/balances',
    name: '提现明细',
    meta: {
      moduleName: '提现明细'
    },
    component: balances,
  },
  {
    path: '/balanceDetail',
    name: '详情',
    meta: {
      moduleName: '详情'
    },
    component: balanceDetail,
  },
  {
    path: '/withdrawal',
    name: '提现',
    meta: {
      moduleName: '提现'
    },
    component: withdrawal,
  },
  {
    path: '/uploadIDCard',
    name: '提交身份证',
    meta: {
      moduleName: '提交身份证'
    },
    component: uploadIDCard,
  },
  {
    path: '/vipTypeInfo',
    name: '会员权益',
    meta: {
      moduleName: '会员权益'
    },
    component: vipTypeInfo,
  },
  {
    path: '/daijiesuan',
    name: '待结算',
    meta: {
      moduleName: '待结算'
    },
    component: daijiesuan,
  },
  {
    path: '/setPassword',
    name: '设置登录密码',
    meta: {
      moduleName: '设置登录密码'
    },
    component: setPassword,
  },
]

export default personalRouter



// WEBPACK FOOTER //
// ./src/router/personal.js